<template>
    <div id="body">
        <b-modal id="confirm-next" ref="confirm-next" dialog-class="modal-custom" hide-footer centered >
            <template #modal-title>
                <h6>Xác nhận</h6>
            </template>
            <div class="d-block text-center">
                <div class="alert mb-0" role="alert">
                    <p class="mb-0">Bạn có chắc chắn muốn chuyển qua phần tiếp theo không?</p>
                    <p class="mb-0">khi chuyển sang phần tiếp theo bạn không thể quay lại phần thi trước</p>
                </div>
                <div>
                    <b-button class="mx-3 fw-bold border border-3 border-dark fst-italic" variant="danger" block @click="$bvModal.hide('confirm-next')">Hủy</b-button>
                    <b-button class="mx-3 fw-bold border border-3 border-dark fst-italic" variant="success" block @click="clearEditorContent(); $bvModal.hide('confirm-next')">Xác nhận</b-button>
                </div>
                <div class="mt-3" v-if="questionAnalytic">
                    <table class="table table-bordered border-success">
                        <tbody>
                            <tr>
                                <th>
                                    <span class="fw-bold fst-italic">Câu đã làm</span>
                                </th>
                                <th>
                                    <span class="fw-bold fst-italic">Câu chưa làm</span>
                                </th>
                                <th>
                                    <span class="fw-bold fst-italic">Câu cần xem lại</span>
                                </th>
                            </tr>
                            <tr>
                                <th>{{ questionAnalytic.resolve }}</th>
                                <th>{{ questionAnalytic.dontResolve}}</th>
                                <th>{{ questionAnalytic.reReview }}</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-modal>
        <b-container class="pb-5">
            <div id="page3 pb-5">
                <div id="test-wapper">
                    <div class="test-header position-relative">
                        <div class="header-time-couter d-flex align-items-center position-absolute">
                            <img src="@/assets/ver2/icons/clock.png" height="40" alt="" class="me-2">
                            <span>{{ $TestApp.getTimeCouter() | secondToMinute }}</span>
                        </div>
                        <img class="cambridge-head" src="@/assets/ver2/nang-luc-cambridge-head.png" alt="">
                        <div class="test-header__info d-flex align-items-end">
                            <div class="test-title-bag headphone">
                                <span>{{ this.partTitle }}</span>
                            </div>
                            <div class="tutorial-test" v-if="Questions.part_type != 1">
                                <div class="tutorial-content">
                                    <div class="tutorial-title">
                                        <span>hướng dẫn làm bài {{ this.partTitle }}</span>
                                    </div>
                                    <div class="tutorial-content__content" v-html="Questions.description" v-if="Questions.part_type != 2"></div>
                                    <!-- <p>Phần thi Listening có 10 câu hỏi.</p>
                                    <p>Bạn hãy nghe và trả lời câu hỏi trong thời gian cho phép</p>
                                    <p>Chúc bạn hoàn thnahf thật tốt bài thi!</p> -->
                                </div>
                            </div>
                            <img src="@/assets/ver2/icons/teacher.png" alt="" class="img-teacher"  v-if="Questions.part_type != 1">
                        </div>
                    </div>
                    <div id="time-box-sticky"></div>
                    <div class="test-box">
                        <div class="paper-header"></div>
                        <div class="paper-body">
                            <div class="part-descreption" v-html="Questions.description" v-if="Questions.part_type == 1"></div>
                            <div class="question-lock-list" v-if="Questions.part_type == 0">
                                <div class="question-block" v-for="(question) in Questions.questions" :key="question.id"  >
                                    <type1 :content="question" v-if="question.content_type == 1 || question.content_type == 2">
                                        <!-- <template v-slot:question-number>
                                            <h2>Question {{ getQuestionNumber(Questions.questions, index) }}</h2>
                                        </template> -->
                                    </type1>
                                    <type3 :content="question" v-if="question.content_type == 3">
                                        <!-- <template v-slot:question-number>
                                            <h2>Question {{ getQuestionNumber(Questions.questions, index) }}</h2>
                                        </template> -->
                                    </type3>
                                    <div v-if="question.content_type == 5">
                                        <b-container>
                                            <b-row>
                                                <b-col lg="12" class="g-0">
                                                    <div class="item_quesion">
                                                        <div class="header_question">
                                                            <div class="title_question ql-editor" style="" v-html="$TestApp.convertAssetsToBlob(question.content)"></div>
                                                        </div>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </b-container>
                                    </div>
                                </div>
                            </div>

                            <div v-if="Questions.part_type == 1" class="part-writing pb-5">
                                <editor v-model="editorData" :resetContent="shouldResetContent" @resetshould="resetshouldContentNew()" />
                            </div>

                            <div v-if="Questions.part_type == 2" class="part-speaking">
                                <type4 :content="Questions" @end-part="$TestApp.nextPart()"></type4>
                            </div>
                        </div>

                        <!-- <div class="paper-footer">
                            <b-button class="paper-footer__nhap me-3">NHÁP</b-button>
                            <b-button class="paper-footer__hotro">HỖ TRỢ GIẢI ĐÁP</b-button>
                        </div> -->
                    </div>
                    <div class="test-button-submit d-flex justify-content-center button-pg1 position-relative" v-if="Questions.part_type != 2">
                        <b-button @click="nextPartAction" variant="transparent">
                            <img src="@/assets/ver2/button_next.png" alt="">
                        </b-button>
                    </div>
                </div>
            </div>
        </b-container>
    </div>
</template>

<script>


// mixins import
import page3Mixin from '@/plugins/TestPlugin/mixins/page3'

export default {
    mixins: [page3Mixin],
    components: {
    },
    computed: {
    },
    data () {
        return {
        editorData: '',
        shouldResetContent: false,
        }
    },
    mounted() {
        window.document.onscroll = () => {
            if(window.scrollY > 300){
                this.navActive = true;
                } else {
                this.navActive = false;
            }
        }

        this.$TestApp.countDownTimer()
    },
    watch: {
    },
    methods: {
        clearEditorContent() {
      if (this.editorData != "") {
         this.$TestApp.writing(this.editorData)
         this.shouldResetContent = true;
      }
      this.$TestApp.nextPart()
    },
    resetshouldContentNew(value){
        this.shouldResetContent = value
    }
    },
    created() {
    }
}
</script>

<style lang="scss">
.tutorial-content__content {

    height: 72px;
    overflow: hidden;

    p {
        margin: 0px;

        strong {
            font-family: 'Montserrat', sans-serif;
            color: #008944 !important;
            font-weight: 900;
        }
    }
}
</style>

<style lang="scss" scoped>

.paper-footer {

    position: absolute;
    bottom: -60px;
    right: -6px;

    button {
        border: 3px solid #000;
        font-family: 'Montserrat', sans-serif !important
    }

    .paper-footer__nhap {
        background-color: #ff9613;
    }

    .paper-footer__hotro {
        background-color: #008944;
    }
}

#page3 {
    padding-bottom: 100px;
}

.test-button-submit {
    width: fit-content;
    margin: auto;
    margin-top: -30px;
}

.test-box {
    
    background-color: #fff;
    position: relative;
    margin-top: 80px;
    padding: 50px;
    padding-top: 30px;
    border-radius: 0px 0px 20px 20px;
    box-shadow: 0px 0px 0px 5px #000;

    .paper-header {
        position: absolute;
        width: 92%;
        @media (min-width:1201px) and (max-width:1400px) {
            width:90.7%
        }
        @media (min-width: 993px) and (max-width: 1023px) {
            width: 85%
        }
        @media (min-width: 1024px) and (max-width: 1200px) {
            width:91%
        }
        background-image: url(~@/assets/ver2/paper-header.png);
        background-repeat: repeat-x;
        background-size: contain;
        height: 50px;
        left: 50%;
        top: -50px;
        transform: translateX(-50%);


        &::before {
            height: 50px;
            width: 59px;
            content: '';
            display: block;
            position: absolute;
            left: -57px;
            background-image: url(~@/assets/ver2/paper-header-left.png);
            background-size: cover;
            top: 0px;
        }

        &::after {
            height: 50px;
            width: 59px;
            content: '';
            display: block;
            position: absolute;
            right: -57px;
            background-image: url(~@/assets/ver2/paper-header-right.png);
            background-size: cover;
            top: 0px;
        }
    }


    .paper-body {
        background-image: url(~@/assets/ver2/paper-line.png);
        background-repeat: repeat;
    }
}

.test-header {
    .header-time-couter {
        width: max-content;
        border-radius: 16px;
        border: 3px solid #000;
        height: -moz-max-content;
        height: max-content;
        font-family: 'Montserrat', sans-serif;
        background: url('~@/assets/ver2/background-button.png');
        color: white;
        text-transform: uppercase;
        font-size: 2rem;
        font-weight: 900;
        text-shadow: 3px 0 #000, -3px 0 #000, 0 2px #000, 0 -3px #000, 2px 2px #000, -2px -2px #000, 2px -2px #000, -2px 2px #000;
        padding: 4px 16px;
        box-shadow: 4px 4px 0px #008844;
        position: relative;
        margin-right: 120px;

        right: -130px;
        top: 0;
        @media (min-width:993px) and (max-width:1400px) {
            top:-3rem
        }
       
        &::after {
            content: '';
            display: block;
            background-image: url(~@/assets/ver2/icons/dots.png);
            height: 10px;
            width: 100px;
            position: absolute;
            bottom: -20px;
            background-repeat: no-repeat;
            background-size: contain;
            left: 50%;
            transform: translateX(-50%);
        }
    }
}



.test-header__info {

    margin-top: -74px;

    .img-teacher {
        height: 180px
    }
        
    .tutorial-test {
        
        width: 100%;

        .tutorial-title {
            position: absolute;
            border-radius: 10px;
            border: 3px solid #000;
            height: max-content;
            width: max-content;
            font-family: 'Montserrat', sans-serif;
            background: url('~@/assets/ver2/background-button.png');
            color: black;
            text-transform: uppercase;
            font-size: 1.2rem;
            font-weight: 900;
            font-style: italic;
            box-shadow: 4px 4px 0px #008844;
            padding: 8px 26px 8px 18px;


            top: -40px;
            left: -36px;

            &::after {
                content: '';
                width: 20px;
                height: 20px;
                display: block;
                position: absolute;
                background: url('~@/assets/ver2/background-button.png');
                bottom: -20px;
                
                border-left: 20px solid transparent;
                border-right: 0px solid transparent;
                border-top: 20px solid #000;
            }

            &::before {
                content: '';
                width: 150px;
                height: 10px;
                display: block;
                position: absolute;
                background-image: url('~@/assets/ver2/icons/dots.png');
                background-repeat: no-repeat;
                background-size: contain;
                right: -45%;
                top: 50%;
                transform: translateY(-50%);
            }
        }

        .tutorial-content {
            position: relative;
            border-radius: 16px;
            border: 3px solid #000;
            background-color: #fff;
            width: 100%;

            padding: 20px;
            padding-bottom: 10px;
            padding-top: 25px;

            p {
                margin-bottom: 0px;
                line-height: 1.3rem;
                font-weight: 600;
            }


        }


    }


    .test-title-bag {
        border-radius: 16px;
        border: 3px solid #000;
        height: max-content;
        font-family: 'Montserrat', sans-serif;
        background: url('~@/assets/ver2/background-button.png');
        color: white;
        text-transform: uppercase;
        font-size: 1.4rem;
        font-weight: 900;
        min-width: 13.5rem;
        font-style: italic;
        text-shadow: 3px 0 #000, -3px 0 #000, 0 2px #000, 0 -3px #000,
               2px 2px #000, -2px -2px #000, 2px -2px #000, -2px 2px #000;
        padding: 10px 26px 10px 18px;
        box-shadow: 4px 4px 0px #008844;
        
        position: relative;
        margin-right: 120px;

        &::after {
            content: '';
            width: 20px;
            height: 20px;
            display: block;
            position: absolute;
            background: url('~@/assets/ver2/background-button.png');
            bottom: -20px;
            
            border-left: 20px solid transparent;
            border-right: 0px solid transparent;
            border-top: 20px solid #000;
        }

        &::before {
            content: '';
            width: 100px;
            height: 100px;
            display: block;
            position: absolute;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: contain;
            right: -90px;
            bottom: -20px;
        }

        &.headphone {
            &::before{
                background-image: url('~@/assets/ver2/icons/headphone.png');
            }
        }
    }
}

</style>